import ImageWithBasePath from './ImageWithBasePath'
import classNames from 'classnames'

export const RedirectLinkButton = ({
  title = 'Redirect',
  className = '',
  onClick = () => {},
  icon = 'rightArrowIcon',
  imageClass = 'ml-[4px] mt-[1px]',
  imageDetails = { width: 20, height: 20 }
}) => {
  return (
    <div
      className="flex cursor-pointer items-center"
      onClick={onClick}
      id="redirection_button_container"
    >
      <h2
        className={classNames(
          'truncate font-noto-sans font-bold leading-[21.79px] text-[#2194F3] mb-[0px]',
          className
        )}
        id="redirection_button_icon"
      >
        {title}
      </h2>
      <div className="flex items-center" id="redirection_button_title">
        <ImageWithBasePath
          src={icon}
          height={imageDetails.height}
          width={imageDetails.width}
          className={imageClass}
          alt="Redirect"
        />
      </div>
    </div>
  )
}
